(() => {
  'use strict';
  let cleanup = () => {};
  function init() {
    cleanup();
    const root = document.querySelector('[data-tickey-root]');
    if (!root) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const timers = [], observers = [];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches;
    const on = (el, name, fn, options = {}) => el?.addEventListener(name, fn, { ...options, signal });
    const every = (fn, ms) => timers.push(setInterval(fn, ms));
    const observe = (el, fn, options) => {
      if (!el) return;
      const observer = new IntersectionObserver(entries => entries.forEach(fn), options);
      observer.observe(el); observers.push(observer);
    };
    const load = video => {
      if (!video || video.dataset.tickeyLoaded) return;
      video.muted = true; video.playsInline = true;
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src; source.removeAttribute('data-src');
      });
      video.dataset.tickeyLoaded = 'true'; video.load();
    };
    const play = video => {
      if (!video || paused || document.hidden) return;
      load(video); video.play().catch(() => {});
    };
    const videos = [...root.querySelectorAll('video')];
    root.querySelectorAll('[data-hero-slideshow]').forEach(show => {
      const slides = [...show.querySelectorAll('.hero-slide')];
      let index = 0;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));
      const update = () => {
        slides.forEach((s, i) => {
          s.classList.toggle('is-active', i === index);
          const v = s.querySelector('video');
          if (v) { if (i === index) play(v); else v.pause(); }
        });
      };
      update();
      every(() => { if (!paused && !document.hidden) { index = (index + 1) % slides.length; update(); } }, 4000);
    });
    const sticky = root.querySelector('#sticky-cta');
    const hero = root.querySelector('#top');
    const updateSticky = () => {
      if (!sticky || !hero) return;
      const show = hero.getBoundingClientRect().bottom <= 24;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show)); sticky.inert = !show;
    };
    on(window, 'scroll', updateSticky, { passive: true });
    on(window, 'resize', updateSticky); updateSticky();
    const syncHeight = () => document.documentElement.style.setProperty('--viewport-h', `${Math.round(window.visualViewport?.height || innerHeight)}px`);
    on(window, 'resize', syncHeight); syncHeight();
    videos.filter(v => !v.matches('[data-app-video]') && !v.closest('[data-hero-slideshow]')).forEach(video => {
      observe(video, entry => {
        video.dataset.tickeyVisible = String(entry.isIntersecting && entry.intersectionRatio >= .35);
        if (video.dataset.tickeyVisible === 'true') play(video);
        else { video.pause(); if (video.classList.contains('viewport-play-video')) video.currentTime = 0; }
      }, { threshold: [0, .35] });
    });
    root.querySelectorAll('[data-app-showcase]').forEach(showcase => {
      const clips = [...showcase.querySelectorAll('[data-app-video]')];
      const tabs = [...showcase.querySelectorAll('[data-app-tab]')];
      let index = 0, visible = false;
      const activate = (next, userAction = false) => {
        index = (next + clips.length) % clips.length;
        clips.forEach((clip, i) => {
          const active = i === index; clip.classList.toggle('is-active', active);
          clip.setAttribute('aria-hidden', String(!active)); clip.setAttribute('role', 'tabpanel');
          clip.dataset.tickeyVisible = String(active && visible);
          if (!active) { clip.pause(); clip.currentTime = 0; }
        });
        tabs.forEach((tab, i) => { tab.classList.toggle('is-active', i === index); tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        load(clips[index]);
        if (visible) { if (userAction && paused) clips[index].play().catch(() => {}); else play(clips[index]); }
      };
      tabs.forEach((tab, i) => {
        on(tab, 'click', () => activate(i, true));
        on(tab, 'keydown', event => {
          const key = event.key;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
          event.preventDefault();
          const next = key === 'Home' ? 0 : key === 'End' ? tabs.length - 1 : (i + (key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[next].focus(); activate(next, true);
        });
      });
      clips.forEach((clip, i) => on(clip, 'ended', () => { if (i === index && !paused) activate(index + 1); }));
      observe(showcase, entry => { visible = entry.isIntersecting && entry.intersectionRatio >= .35; clips[index].dataset.tickeyVisible = String(visible); if (visible) play(clips[index]); else clips[index].pause(); }, { threshold: [0, .35] });
      activate(0);
    });
    root.querySelectorAll('[data-compare]').forEach(slider => {
      const range = slider.querySelector('.compare-range');
      if (range) { const update = () => slider.style.setProperty('--split', `${range.value}%`); on(range, 'input', update); update(); }
    });
    const toggle = root.querySelector('.tickey-motion-toggle');
    const syncPaused = () => {
      root.classList.toggle('tickey-motion-paused', paused);
      toggle?.setAttribute('aria-pressed', String(paused));
      toggle?.setAttribute('aria-label', paused ? 'Resume decorative motion' : 'Pause decorative motion');
      const label = toggle?.querySelector('[data-motion-label]'); if (label) label.textContent = paused ? 'Play motion' : 'Pause motion';
      videos.forEach(v => { if (paused) v.pause(); else if (v.dataset.tickeyVisible === 'true' || v.closest('.hero-slide.is-active')) play(v); });
    };
    on(toggle, 'click', () => { paused = !paused; syncPaused(); });
    on(reduced, 'change', () => { paused = reduced.matches; syncPaused(); });
    on(document, 'visibilitychange', () => { if (document.hidden) videos.forEach(v => v.pause()); else syncPaused(); });
    syncPaused();
    const menuButton = document.querySelector('.tickey-menu-toggle');
    const menu = document.querySelector('.tickey-nav');
    const setMenu = open => { menu?.classList.toggle('is-open', open); menuButton?.setAttribute('aria-expanded', String(open)); };
    on(menuButton, 'click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true'));
    menu?.querySelectorAll('a').forEach(a => on(a, 'click', () => setMenu(false)));
    on(document, 'keydown', e => { if (e.key === 'Escape' && menu?.classList.contains('is-open')) { setMenu(false); menuButton.focus(); } });
    cleanup = () => { controller.abort(); timers.forEach(clearInterval); observers.forEach(o => o.disconnect()); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
